import itemDeadlineReducer from './item-deadline';
export * from './item-deadline';

export default { itemDeadline: itemDeadlineReducer };
